import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";

const About = () => {
  const credentials = [
    "Medicina",
    "Pós-graduação em Nutrologia",
    "Formação em Medicina Intensiva",
    "Mentoria Médico de Excelência",
  ];

  return (
    <section
      id="sobre"
      className="bg-[#FDFBF7] py-20 md:py-32"
      data-testid="about-section"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 md:px-12 lg:grid-cols-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative lg:col-span-5"
        >
          <div className="absolute -inset-3 rounded-[2.5rem] border border-[#D4AF37]/30" />
          <img
            src="https://customer-assets-eiarnc6j.emergentagent.net/job_metodo-mariana/artifacts/3nee18jz_IMG_0544.JPG"
            alt="Dra. Mariana Alves"
            className="relative h-[600px] w-full rounded-[2rem] object-cover"
            data-testid="about-image"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Quem sou eu
          </p>
          <h2
            className="font-serif text-3xl leading-tight text-[#3E2723] sm:text-4xl lg:text-5xl gold-line"
            data-testid="about-title"
          >
            Dra. Mariana Alves
          </h2>

          <div className="mt-8 space-y-5 text-base leading-relaxed text-[#4E342E]/85 md:text-lg">
            <p className="font-serif text-xl italic text-[#5D4037]">
              Cuidar da saúde é muito mais do que perder peso.
            </p>
            <p>
              Sou médica desde 2016 e dedico minha carreira a ajudar mulheres
              que desejam transformar sua saúde de forma inteligente, segura e
              duradoura.
            </p>
            <p>
              Acredito que cada paciente possui uma história única e merece um
              plano individualizado, construído com base em ciência,
              acompanhamento próximo e estratégia.
            </p>
            <p>
              Minha missão é ajudar mulheres a recuperarem não apenas resultados
              estéticos, mas também energia, disposição, autoestima e qualidade
              de vida.
            </p>
          </div>

          <div className="mt-10">
            <p className="mb-4 flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#795548]">
              <GraduationCap className="h-4 w-4 text-[#D4AF37]" />
              Formação
            </p>
            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {credentials.map((c, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 rounded-2xl border border-[#EFEBE1] bg-white px-5 py-4 transition-all hover:border-[#D4AF37]/40 hover:shadow-md"
                  data-testid={`credential-${i}`}
                >
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[#D4AF37]" />
                  <span className="text-sm text-[#3E2723]">{c}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-sm italic text-[#795548]">
              Atualização constante através de congressos, estudos e programas
              avançados voltados à saúde feminina e composição corporal.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
